module.exports = __webpack_public_path__ + "static/media/IRANSansWeb(FaNum).bab5e043.ttf";